module.exports = __webpack_public_path__ + "img/zfcg_17.51813ece.png";